import React from 'react';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { visualizarReporteEnPdf, generarReporteEnExcel } from '../../funciones_globales/interaccionApiReportes';
import { formatearNumeroEntero } from '../../funciones_globales/format';
import { cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import global_axios from '../../funciones_globales/interaccionapi';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';

class FormVen36  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            periodo: '',
            mes_sel: null,
            mes_opt: [],          
            anioActual: null,            
            opciones: 'S',
        };
        
        this.changeComponents = this.changeComponents.bind(this);        
        this.limpiar = this.limpiar.bind(this);
        //this.generarRptExistenciaPorBodega = this.generarRptExistenciaPorBodega.bind(this);
        this.generarRptDetalleComision = this.generarRptDetalleComision.bind(this);
        
        this.validarPeriodoSeleccionado = this.validarPeriodoSeleccionado.bind(this);
        this.validarMesSeleccionado = this.validarMesSeleccionado.bind(this);
    }

    changeComponents(event){

        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        
        this.setState({[name]: value});
    }

    

    validarPeriodoSeleccionado(){        
        try {            
            if(this.state.periodo!==''){
                let anio = formatearNumeroEntero(this.state.periodo);
                let fechaInf = formatearNumeroEntero(this.state.anioActual) - 3;
    
                if(anio>formatearNumeroEntero(this.state.anioActual)){
                    this.setState({periodo: formatearNumeroEntero(this.state.anioActual)});
                }else if(anio===formatearNumeroEntero(this.state.anioActual)){
                    this.setState({periodo: anio});
                }else if(anio >= fechaInf && anio <=formatearNumeroEntero(this.state.anioActual)){
                    this.setState({periodo: anio});
                }else{
                    this.setState({periodo: fechaInf});
                    alert(`Sólo puede consultar información de los últimos 3 años.`);
                }
            }   
        } catch (error) {
            alert(`Ocurrió un error al validar el periodo seleccionado. Error: ${error}`);
        }    
    }

    validarMesSeleccionado(){    
        try {
            let response = true;

            let fechaProceso = getFechaProcesoPorModulo('04');
            let mesActual = formatearNumeroEntero(fechaProceso.toString().split('/')[1]);
            let anioActual = formatearNumeroEntero(fechaProceso.toString().split('/')[2]);
            if( formatearNumeroEntero(this.state.periodo) === anioActual){
                if( formatearNumeroEntero(this.state.mes_sel) > mesActual){
                    alert(`Sólo puede consultar información hasta el periodo y mes actual.`);
                    response = false;
                }
            }
            return response;
        } catch (error) {
            alert(`Ocurrió un error al validar el mes seleccionado. Error: ${error}`);
            return false;
        }
    }

    componentDidMount(){
        Promise.all([            
            cargarCatalogos_Otros('MESES'),            
            this.props.generar_LogAuditoriaIngresoForm('0436')
         ])
        .then(([ meses ]) => {
            let fechaProceso = getFechaProcesoPorModulo('04');

            if (fechaProceso !== null){
                let anioActual = fechaProceso.toString().split("/")[2];
                let mesActual = fechaProceso.toString().split("/")[1];                
                this.setState({  mes_opt: meses, anioActual: formatearNumeroEntero(anioActual),
                                periodo: parseInt(anioActual,10), mes_sel: mesActual });
            }
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0436');
    }    

    limpiar(){
        this.setState({
                  opciones: 'S'
        });
    }

    
    generarRptResumenComision(formatoReporte){
        try {                        

            var continuar = true;
            var error = "";
            
            if(this.state.periodo==='' || this.state.mes_sel===null){
                continuar = false;
                error=error+"- Ingrese periodo y mes para la consulta."
            }

            if(this.state.periodo!=='' && this.state.mes_sel!==null){
                if(this.validarMesSeleccionado()===false){
                    continuar = false;
                }
            }
                
            

            if(continuar === true){
                
                let rptUrlWithParams = `&param1=${this.state.periodo}&param2=${this.state.mes_sel}`;
            
                if (formatoReporte==='PDF'){
                    rptUrlWithParams = `&rpt=152`.concat(rptUrlWithParams);
                    visualizarReporteEnPdf(rptUrlWithParams);
                }else{
                    rptUrlWithParams = `&rpt=151`.concat(rptUrlWithParams);                
                    generarReporteEnExcel(rptUrlWithParams);
                }
            }else if(error!==''){
                alert(error);
            }
        } catch (error) {
            alert(`Ocurrió un error al intentar generar el reporte. Error: ${error}`);
        }

    }

    generarRptDetalleComision(formatoReporte){
        try {                        

            var continuar = true;
            var error = "";
            
            if(this.state.periodo==='' || this.state.mes_sel===null){
                continuar = false;
                error=error+"- Ingrese periodo y mes para la consulta."
            }

            if(this.state.periodo!=='' && this.state.mes_sel!==null){
                if(this.validarMesSeleccionado()===false){
                    continuar = false;
                }
            }
                
            

            if(continuar === true){
                
                let rptUrlWithParams = `&param1=${this.state.periodo}&param2=${this.state.mes_sel}`;
            
                if (formatoReporte==='PDF'){
                    rptUrlWithParams = `&rpt=150`.concat(rptUrlWithParams);
                    visualizarReporteEnPdf(rptUrlWithParams);
                }else{
                    rptUrlWithParams = `&rpt=151`.concat(rptUrlWithParams);                
                    generarReporteEnExcel(rptUrlWithParams);
                }
            }else if(error!==''){
                alert(error);
            }
        } catch (error) {
            alert(`Ocurrió un error al intentar generar el reporte. Error: ${error}`);
        }

    }

    generaComisionComercial(){
        try {                        
            let dataEnvio = {};
            var continuar = true;
            var error = "";
            
            if(this.state.periodo==='' || this.state.mes_sel===null){
                continuar = false;
                error=error+"- Ingrese periodo y mes para la consulta."
            }

            if(this.state.periodo!=='' && this.state.mes_sel!==null){
                if(this.validarMesSeleccionado()===false){
                    continuar = false;
                }
            }
            
            

            if(continuar === true){
                let resp = window.confirm("Desea Generar la informaicon para Comision del Dept. Comercial en el periodo y mes seleccionado?")
                if(resp){
                    dataEnvio.periodo= this.state.periodo;     
                    dataEnvio.mes= this.state.mes_sel;     

                    let config_request = {
                        method: 'POST',
                        url: '/comisioncomercial',
                        data: dataEnvio }
                        this.props.cambiar_VisualizacionLoading(true);
                        global_axios(config_request)
                        .then((response)=>{
                            this.props.cambiar_VisualizacionLoading(false);
                            alert("Información generada con éxito para el periodo y mes seleccionado")
                        })
                        .catch((error)=>{
                            this.props.cambiar_VisualizacionLoading(false);
                            alert(error.response?error.response.data.msg:error.message);
                        });
                    }
                
            }else if(error!==''){
                alert(error);
            }
        } catch (error) {
            alert(`Ocurrió un error al intentar generar el reporte. Error: ${error}`);
        }

    }

    generarRptExistenciaPorBodega(formatoReporte){
        try {                        

            var continuar = true;
            var error = "";
            var opcion = 'B'
            if(this.state.periodo==='' || this.state.mes_sel===null){
                continuar = false;
                error=error+"- Ingrese periodo y mes para la consulta."
            }

            if(this.state.periodo!=='' && this.state.mes_sel!==null){
                if(this.validarMesSeleccionado()===false){
                    continuar = false;
                }
            }
                
            

            if(continuar === true){
                
                let rptUrlWithParams = `&param1=${opcion}&param2=${this.state.periodo}&param3=${this.state.mes_sel}`;
                if(this.state.bodega_sel!==null){
                    rptUrlWithParams += `&param4=${this.state.bodega_sel}`;
                }

                

                if(this.state.opciones!==null){
                    rptUrlWithParams += `&param9=${this.state.opciones}`;
                }
            
                if (formatoReporte==='PDF'){
                    rptUrlWithParams = `&rpt=24`.concat(rptUrlWithParams);
                    visualizarReporteEnPdf(rptUrlWithParams);
                }else{
                    rptUrlWithParams = `&rpt=48`.concat(rptUrlWithParams);                
                    generarReporteEnExcel(rptUrlWithParams);
                }
            }else if(error!==''){
                alert(error);
            }
        } catch (error) {
            alert(`Ocurrió un error al intentar generar el reporte. Error: ${error}`);
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
                <HeaderForm>
                    <TituloForm>Comision Comercial</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <Row>                        
                        <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='4'>
                            <LabelForm>Periodo:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='4'>
                            <InputText name='periodo' value={this.state.periodo} type="number" className='form-control input-sm'  
                            onChange={this.changeComponents} onBlur={this.validarPeriodoSeleccionado}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_abajo='4'>
                            <LabelForm>Mes:</LabelForm>
                        </ContainerCol>                
                        <ContainerCol className='col-sm-4' margen_abajo='4'>
                            <ReactSelect options={ this.state.mes_opt } value={this.state.mes_sel} 
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({mes_sel: value!==null?value.value:null})}}
                                func_onBlur={this.validarMesSeleccionado}/>
                        </ContainerCol>
                    </Row>
                    
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.periodo===''||this.state.mes_sel===null?true:false} onClick={()=>{this.generaComisionComercial()}}><i className="fa fa-refresh" aria-hidden="true"/> Generar</button>  
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.periodo===''||this.state.mes_sel===null?true:false} onClick={()=>{this.generarRptResumenComision('PDF')}}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir Comision</button>  
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.periodo===''||this.state.mes_sel===null?true:false} onClick={()=>{this.generarRptDetalleComision('PDF')}}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir Detalle</button>  
                                <button type='button' className='btn btn-success btn-sm' disabled={this.state.periodo===''||this.state.mes_sel===null?true:false} onClick={()=>{this.generarRptDetalleComision('EXCEL')}}><i className="fa fa-file-excel-o fa-lg" aria-hidden="true"/> Imprimir Detalle Excel</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}
 
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cambiar_VisualizacionLoading}, dispatch)
});
  
export default connect (null, mapDispatchToProps)(FormVen36);